const getAddressLine2 = (
  isAmericanFormat: boolean,
  city: string,
  postalCode?: string | null,
  addressRegion?: string | null,
) => {
  if (!postalCode) {
    return city;
  }
  const stem = addressRegion ? `${city}, ${addressRegion}` : city;
  return isAmericanFormat
    ? `${stem} ${postalCode}`
    : `${postalCode} ${city}`;
};

export default getAddressLine2;
